<!-- ========== Left Sidebar Start ========== -->
<app-side-menu (sideNavMessage$)="listenerNav($event)" [language]="language" [compact]="false"></app-side-menu>
<!-- Left Sidebar End -->
<!-- Navbar Start -->
<app-nav-bar (navMessage$)="listenerNav($event)"></app-nav-bar>
<!-- end Navbar -->
<!-- Footer Start -->
<div class="content-page bg-gray">
    <div class="content text-dark">
        <div class="d-flex align-items-center col-md-12 col-sm-12">
            <nav style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
                <ol class="breadcrumb text-capitalize text-dark h5">
                    <li class="breadcrumb-item"><a [routerLink]="['/sales']" class="text-secondary">Sales</a></li>
                    @if (sale !== null) {
                    <li class="breadcrumb-item">
                        <a [routerLink]="['/sales', saleId]" class="text-secondary">{{sale.buyer}} &ndash; {{sale.vehicle}}</a>
                    </li>
                    }
                    <li class="breadcrumb-item text-secondary" aria-current="page">Manage Insurance</li>
                </ol>
            </nav>
            <div class="ml-auto align-items-center"></div>
        </div>
    </div>

    @if (saleId && sale) {
    <section>
        <div class="card-deck">
            <div class="card">
                <div class="card-body">
                    <h3>{{sale.buyer}}</h3>
                    <p class="subtitle">Buyer</p>
                </div>
                <div class="card-footer">
                    <a href="#" class="card-link" [routerLink]="['/contacts', sale.contactId]">Jump to Contact</a>
                </div>
            </div>

            <div class="card">
                <div class="card-body vehicle">
                    @if (sale.url) {
                    <img [src]="sale.url" />
                    }
                    @else {
                    <span class="material-icons">directions_car</span>
                    }
                    <div>
                        <h3>{{sale.vehicle}}</h3>
                        <p class="subtitle">{{sale.stock}}</p>
                    </div>
                </div>
                <div class="card-footer">
                    <a href="#" class="card-link" [routerLink]="['/sales', saleId]">Jump to Sale</a>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <h3>{{sale.saleDate | date:'E MMM d, yyyy'}}</h3>
                    <p class="subtitle text-truncate">{{sale.status}} | {{sale.payment | currency}} ({{sale.paymentCycle | lowercase}}) | Payoff: {{sale.payoff | currency}}</p>
                </div>
                <div class="card-footer">
                    <a href="#" class="card-link" [routerLink]="['/collections', sale.contactId]">Jump to Collections</a>
                </div>
            </div>
        </div>
    </section>
    }

    <main>
        <ul class="nav nav-tabs nav-justified nav-bordered">
            @if (!sale || (sale && sale.financed)) {
                <li class="nav-item">
                    <a href="#cpi-detail" id="cpi-detail-link" data-toggle="tab" aria-expanded="false" class="nav-link">
                        <span class="mdi mdi-home-variant d-md-none d-block"></span>
                        <span class="d-none d-md-block">CPI</span>
                    </a>
                </li>
            }
            <li class="nav-item">
                <a href="#personal-detail" id="personal-detail-link" data-toggle="tab" aria-expanded="true" class="nav-link">
                    <span class="mdi mdi-account-circle d-md-none d-block"></span>
                    <span class="d-none d-md-block">Outside Insurance</span>
                </a>
            </li>
            <li class="nav-item">
                <a href="#inactive-policies" id="inactive-policies-link" data-toggle="tab" aria-expanded="true" class="nav-link">
                    <span class="mdi mdi-account-circle d-md-none d-block"></span>
                    <span class="d-none d-md-block">Inactive / Cancelled Policies</span>
                </a>
            </li>
        </ul>

        <div class="tab-content">
            @if (!sale || (sale && sale.financed)) {
                <div id="cpi-detail" class="tab-pane">
                    <cpi [saleId]="saleId" [sale]="sale" [cpiPolicyInfo]="cpiPolicyInfo" (emitterInformation$)="listenerChildrens($event)"></cpi>
                </div>
            }
            <div id="personal-detail" class="tab-pane">
                <outside-insurance [saleId]="saleId" [sale]="sale" [outsideInsurancePolicyInfo]="outsideInsurancePolicyInfo" (emitterInformation$)="listenerChildrens($event)"></outside-insurance>
            </div>
            <div id="inactive-policies" class="tab-pane">
                <div class="card">
                    <div class="card-body">
                        <ul class="list-group list-group-flush">
                            @for (policy of inactivePolicies; track policy.id; let i = $index) {
                                <li class="list-group-item">
                                    <p><span class="material-icons">cancel</span></p>
                                    <p class="past">{{policy.inactiveDate | date:'E MMM dd, yy'}}</p>
                                    <p>{{policy.contact.name}}</p>
                                    <p>{{policy.endDate | date:'E MMM dd, yy'}}</p>
                                    <p (click)="clone(policy)" data-toggle="modal" data-target="#duplicatePolicyModal"><span class="material-icons">check</span></p>
                                </li>
                            }
                            @empty {
                                <li class="list-group-item empty">No inactive policies found.</li>
                            }
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>

<!-- warning modal -->
<div class="modal fade" id="duplicatePolicyModal" data-backdrop="static" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body d-flex flex-wrap align-items-center justify-content-center">
                <span class="dripicons-warning text-warning display-3"></span>
                <h4 class="text-warning w-100 text-center">Duplicate</h4>
                <span class="text-dark my-1 text-center">Are you sure you want to duplicate this policy?</span>
                <button class="btn btn-warning mt-2" (click)="duplicatePolicy()" [disabled]="loading">
                    @if (loading) {
                    <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
                    }
                    Yes</button>
                <button class="btn btn-secondary mt-2 ml-2" data-dismiss="modal" id="btn-close-modal-duplicate">No</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->